import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import AppConsts from "../../../libs/AppConsts";

const DocumentPage = () => {
  const { documentType } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const timerId = useRef<NodeJS.Timeout | null>(null);

  const documents = {
    "privacy-policy": {
      url: `${AppConsts.host}system-files/Политика_конфиденциальности_РФ_Flite_CRM_2025.docx`,
      title: "Политика конфиденциальности",
    },
    "offer-agreement": {
      url: `${AppConsts.host}system-files/Лицензионный_договор_оферта_РФ_Flite_CRM_2025.pdf`,
      title: "Лицензионный договор оферта",
    },
    "consent-personal-data": {
      url: `${AppConsts.host}system-files/Согласие_на_обработку_персональных_данных_РФ_Flite_CRM_2025.docx`,
      title: "Согласие на обработку персональных данных",
    },
    "personal-data-agreement": {
      url: `${AppConsts.host}system-files/Согласие_на_получение_инф_и_рекламной_рассылки_РФ_Flite_CRM_2025.docx`,
      title: "Согласие на получение информационной и рекламной рассылки",
    },
  };

  const document = documents[documentType as keyof typeof documents];

  useEffect(() => {
    if (!document) return;

    const reloadIFrame = () => {
      const iframe = iframeRef.current;
      if (!iframe || !iframe.contentDocument) return;

      try {
        const url = iframe.contentDocument.URL;
        console.log("iframe URL check:", url);
        if (url === "about:blank") {
          console.warn("Iframe is blank — reloading...");
          iframe.src = iframe.src;
        }
      } catch (err) {
        console.log("Could not access iframe content:", err);
      }
    };

    timerId.current = setInterval(reloadIFrame, 1000);

    const iframe = iframeRef.current;
    const handleLoad = () => {
      if (timerId.current) {
        clearInterval(timerId.current);
        timerId.current = null;
      }
      setIsLoading(false);
      console.log("Finally Loaded");
    };

    if (iframe) iframe.addEventListener("load", handleLoad);

    return () => {
      if (timerId.current) clearInterval(timerId.current);
      if (iframe) iframe.removeEventListener("load", handleLoad);
    };
  }, [document]);

  if (!document) {
    return <div style={{ padding: "20px" }}>Документ не найден</div>;
  }

  return (
    <div style={{ padding: "20px", height: "100vh", position: "relative" }}>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,255,255,0.8)",
            zIndex: 1,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      <iframe
        ref={iframeRef}
        id="iFrame"
        src={`https://docs.google.com/gview?url=${document.url}&embedded=true`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: isLoading ? "none" : "block",
        }}
        title={document.title}
      />
    </div>
  );
};

export default DocumentPage;